import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'stores'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getStore (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  getStoreAndProducts (link) {
    return Client.get(`${resource}/${link}/products`)
      .then(response => response.data)
  },
  isStoreOpen (accountId) {
    return Client.get(`${resource}/status/open?accountId=${accountId}`)
  },
  closeStore (accountId, year) {
    return Client.post(`${resource}/status/close`, { account_id: accountId, year: year })
  },
  getSalesTaxRate (zip) {
    return Client.get(`${resource}/sales-tax/rate?zip=${zip}`)
  }
}
